export enum PaymentFeeType {
	SingleOrSingleFuturePayment,
	PaymentPlan,
	Autopay
}
